export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未找到用户"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])}
}